<template>
    <div v-if="app_settings.payments.registration">
        <RegistrationLayout
            :loan-possibility="
                app_settings.payments.registration_possibility
                    ? app_settings.payments.registration_possibility
                    : loanPossibility
            "
            :phase="1 + +app_settings.payments.after_check_requisites"
            :hide-info-box="true"
        >
            <v-card-text class="registration-card">
                <div>
                    <InfoBox :icon="icon">
                        <template v-slot:text>
                            <span
                                v-html="
                                    $t(
                                        app_settings.payments.registration_help_text
                                            ? app_settings.payments.registration_help_text
                                            : 'pay.help_text'
                                    )
                                "
                            ></span>
                            <div class="mt-4">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <a v-on="on">{{ $t("pay.why") }}</a>
                                    </template>
                                    <span v-html="$t('pay.why_hint')"></span>
                                </v-tooltip>
                            </div>
                        </template>
                    </InfoBox>
                </div>
                <div class="mt-4" v-if="provider === 'payment_center'">
                    <PaymentCenterOrder
                        :user-id="user.id"
                        :on-success="paymentSuccess"
                        :on-cancel="paymentDecline"
                        :on-decline="paymentDecline"
                    ></PaymentCenterOrder>
                </div>
                <div class="mt-4" v-if="provider === 'fondy'">
                    <FondyOrder
                        :user-id="user.id"
                        :on-success="paymentSuccess"
                        :on-cancel="paymentDecline"
                        :on-decline="paymentDecline"
                    ></FondyOrder>
                </div>
                <div class="pay-info mt-2">
                    <a @click="showPaymentInfo = !showPaymentInfo">{{ $t("pay.more_info") }}</a>
                    <a
                        v-if="app_settings.payments.pass_registration"
                        class="float-right pass-payment"
                        @click="next()"
                        >{{ $t("pay.pass") }}
                    </a>
                    <v-expand-transition>
                        <p v-if="showPaymentInfo">
                            {{ $t("pay.info", { host }) }}
                        </p>
                    </v-expand-transition>
                </div>
            </v-card-text>
        </RegistrationLayout>
    </div>
</template>

<script>
import settings from "@/environment";
import InfoBox from "@/app/mobile/ui/InfoBox";
import iconHeart from "@/assets/img/icon-heart.png";
import RegistrationLayout from "@/app/mobile/registration/shared/components/Layout";
import PaymentCenterOrder from "@/app/shared/components/app-payments/PaymentCenterOrder";
import FondyOrder from "@/app/shared/components/app-payments/FondyOrder";
import AxiosClient from "../../../shared/services/http-client/axios";

export default {
    name: "RegistrationPaymentStep",
    components: {
        RegistrationLayout,
        PaymentCenterOrder,
        InfoBox,
        FondyOrder,
    },
    data() {
        return {
            showPaymentInfo: false,
            icon: iconHeart,
            settings: settings,
            host: window.location.hostname,
            provider: undefined,
        };
    },
    created() {
        this.getPaymentProvider();
        if (!this.app_settings.payments.enabled || !this.app_settings.payments.registration)
            this.checkRequisites();
    },
    computed: {
        loanPossibility() {
            return this.$store.getters.LOAN_POSSIBILITY;
        },
        user() {
            return this.$store.getters.GET_REGISTRATED_USER;
        },
        app_settings() {
            return this.$store.getters.APP_SETTINGS;
        },
    },
    methods: {
        getPaymentProvider() {
            AxiosClient.get("/payment/payment-provider").then((response) => {
                this.provider = response.data.provider;
            });
        },
        next() {
            if (
                this.app_settings.payments.enabled &&
                this.app_settings.payments.registration &&
                this.app_settings.payments.after_check_requisites
            ) {
                this.completeRegistration();
            } else {
                this.checkRequisites();
            }
        },
        checkRequisites() {
            this.$router.push({
                path: `/check-requisites?api_key=${this.user.api_key}`,
            });
        },
        completeRegistration() {
            this.$store
                .dispatch("COMPLETE_REGISTRATION")
                .then((user) => {
                    this.$store
                        .dispatch("AUTH_BY_API_KEY", user.api_key)
                        .then(() => {
                            this.$router.push({ path: "/panel/offers" });
                        })
                        .catch(() => {
                            this.$toast.error(this.$t("errors.unknown_error"));
                        });
                })
                .catch(() => {
                    this.$toast.error(this.$t("errors.unknown_error"));
                });
        },
        paymentSuccess() {
            localStorage.setItem("creditCardAttached", 1);
            this.next();
        },
        paymentDecline() {
            this.$toast.error(this.$t("pay.decline"));
        },
    },
};
</script>

<style>
.pay-info a {
    font-size: 11px !important;
    text-align: center;
}

.pay-info p {
    font-size: 11px;
    line-height: 1.5;
    text-align: justify;
    color: #bbbbbb;
}

.pass-payment {
    color: #aaaaaa !important;
}
</style>
